__turbopack_context__.v({
  "container": "TheJourney-module__kIcEFa__container",
  "content": "TheJourney-module__kIcEFa__content",
  "iconWrapper": "TheJourney-module__kIcEFa__iconWrapper",
  "itemTexts": "TheJourney-module__kIcEFa__itemTexts",
  "itemTitle": "TheJourney-module__kIcEFa__itemTitle",
  "journeyItem": "TheJourney-module__kIcEFa__journeyItem",
  "phaseCard": "TheJourney-module__kIcEFa__phaseCard",
  "phaseHeader": "TheJourney-module__kIcEFa__phaseHeader",
  "phaseLabel": "TheJourney-module__kIcEFa__phaseLabel",
  "subTitle": "TheJourney-module__kIcEFa__subTitle",
  "subTitleUnderline": "TheJourney-module__kIcEFa__subTitleUnderline",
  "timeline": "TheJourney-module__kIcEFa__timeline",
});
